<style scoped>
.mu-icon-button.mu-button-small {
  width: 24px;
  height: 24px;
}
.mu-form-item .mu-button {
  margin: 3px 4px;
}
.mu-form-item {
  margin-bottom: 0px;
  padding-bottom: 0px;
  min-height: 0px;
}
.mu-flat-button.mu-button-small {
  font-size: 14px;
  height: 14px;
}
.duration-text {
  line-height: 24px;
  vertical-align: text-bottom;
}
.not-support-text {
  padding-left: 4px;
  padding-right: 4px;
  color: red;
}
</style>

<template>
  <div>
    <div v-if="!isSubmitted && recorderSupport">
      <mu-button @click="!recording ? onStart() : onEnd()" small :color="recording ? 'secondary' : 'primary'" :disabled="uploading">
        <mu-icon :value="uploading ? 'cached' : (recording ? 'stop' : 'fiber_manual_record')"/> {{$t('voice.' + (uploading ? 'uploading' : (recording ? 'end' : 'start')))}}
      </mu-button>
      <span v-if="blob">
        <mu-button small icon>
          <mu-icon value="audiotrack" />
        </mu-button>
        <span class="duration-text">{{computedDuration}}</span>
        <mu-button small icon @click="onPlay">
          <mu-icon value="play_arrow" />
        </mu-button>
      </span>
    </div>
    <small class="not-support-text" v-if="!recorderSupport && !isSubmitted">
      {{$t('voice.notSupport')}}
    </small>
    <div>
      <AudioItem
        v-for="(attachment, index) in attachments"
        :attachment="attachment"
        @onDelete="onDelete(index)"
        :isSubmitted="isSubmitted"
        />
    </div>
  </div>
</template>

<script>
import '@/utils/recorder.mp3.min.js'

import timeFormatter from '@/utils/timeFormatter.js'

import AudioItem from '@/components/Common/AudioItem.vue'

// Library
import axios from "axios";

export default {
  name: 'VoiceInput',
  components: {
    AudioItem,
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      }
    },
    isSubmitted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: JSON.parse(JSON.stringify(this.value)),
      rev: null,
      audio: null,

      recording: false,
      blob: null,
      duration: null,
      attachments: [],

      uploading: false,
      recorderSupport: false,
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if(Array.isArray(newValue) && newValue.length > 0) {
          this.fetchAttachments();
        } else {
          this.attachments = [];
        }
      },
      deep: true
    },
    data: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    },
  },
  computed: {
    computedDuration() {
      return timeFormatter(this.duration / 1000);
    }
  },
  mounted() {
    if(window.Recorder.Support()) {
      this.recorderSupport = true;
      this.rec = window.Recorder({type:"mp3",sampleRate:16000});
      this.initAudio();
    }
    if(this.data.length > 0) {
      this.fetchAttachments();
    }
  },
  methods: {
    fetchAttachments() {
      axios.get(this.$store.getters.urlApi + "attachment?ids=" + JSON.stringify(this.data), {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.attachments = response.data.data.attachments;
      });
    },
    initAudio() {
      this.audio = document.createElement("audio");
      this.audio.controls=true;
      document.body.appendChild(this.audio);
    },
    onStart() {
      this.rec.open(() => {
        this.recording = true;
        this.rec.start();
      },function(msg,isUserNotAllow){
          console.log((isUserNotAllow?"UserNotAllow，":"")+"Cannot record due to user not allow:"+msg);
      });
    },
    onEnd() {
      this.rec.stop((blob,duration) => {
        console.log((window.URL||webkitURL).createObjectURL(blob),"Duration: "+duration+"ms");
        this.duration = duration;
        this.rec.close();
        this.blob = blob;
        this.audio.src=(window.URL||webkitURL).createObjectURL(this.blob);
        this.recording = false;
        this.onActionUpload();
      },function(msg){
        console.log("Record fail: "+msg);
      });
    },
    onPlay() {
      this.audio.play();
    },
    onClear() {
      this.audio.src = '';
      this.blob = null;
    },
    onSave() {
      this.onActionUpload();
    },
    onActionUpload() {
      if(!this.uploading) {
        this.uploading = true;
        const formData = new FormData();
        formData.append('file[]', this.blob, Date.now() + '.mp3');
        formData.append('duration', this.duration);

        axios.post(this.$store.getters.urlApi + "attachment", formData, {
          headers: {
            token: this.$store.state.auth.token
          },
        }).then(response => {
          this.uploading = false;
          var i;
          for (i = 0; i < response.data.data.attachments.length; i++) {
            this.data.push(response.data.data.attachments[i]._id);
          }
          this.onClear();
          this.fetchAttachments();
          this.$toast.success(this.$t('toast.create'));
        });
      }
    },
    onDelete(index) {
      axios.delete(this.$store.getters.urlApi + "attachment/" + this.data[index], {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(() => {
        this.data.splice(index, 1);
        this.attachments.splice(index, 1);
        this.$toast.success(this.$t('toast.delete'));
      });
    },
  },
}

</script>
